import { Button, Tag, Popconfirm } from "antd";
import React from "react";
import Moment from "react-moment";
import "moment-timezone";

export default (onUpdate, onDelete) => [
  {
    title: "Create Date",
    dataIndex: "created",
    align: "center",
    render: (created) => {
      return (
        <Moment unix tz="Etc/UTC" format="DD/MM/YY HH:mm">
          {new Date(created.Time)}
        </Moment>
      );
    },
  },
  {
    title: "MemberID",
    align: "center",
    dataIndex: "member_id",
  },
  {
    title: "Email",
    dataIndex: "email",
    align: "center",
  },
  {
    title: "Value",
    dataIndex: "value",
    align: "center",
    render: (val) => {
      if (val === "inactive") {
        return <Tag color="red">Not Allowed</Tag>;
      }
      return <Tag color="green">Allowed</Tag>;
    },
  },
  {
    title: "Status",
    dataIndex: "status",
    align: "center",
    render: (text) => {
      if (text === "disabled") {
        return <Tag color="red">Disabled</Tag>;
      }
      if (text === "deleted") {
        return <Tag color="grey">Deleted</Tag>;
      }
      return <Tag color="green">Enabled</Tag>;
    },
  },
  {
    title: "Action",
    align: "center",
    render: (record) => {
      return (
        <Button.Group>
          <Button icon="edit" onClick={() => onUpdate(record)} />
          {record.status !== "deleted" && (
            <Popconfirm
              title="Are you sure you want to delete?"
              okText="Yes"
              cancelText="No"
              onConfirm={() => onDelete(record)}
            >
              <Button type="danger" icon="delete" />
            </Popconfirm>
          )}
        </Button.Group>
      );
    },
  },
];



// WEBPACK FOOTER //
// ./src/containers/Keyword/WhitelistURL/column.js